import { render, staticRenderFns } from "./ProductQuickEditSellPrice.vue?vue&type=template&id=13edf394&scoped=true"
import script from "./ProductQuickEditSellPrice.vue?vue&type=script&lang=ts"
export * from "./ProductQuickEditSellPrice.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13edf394",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('13edf394')) {
      api.createRecord('13edf394', component.options)
    } else {
      api.reload('13edf394', component.options)
    }
    module.hot.accept("./ProductQuickEditSellPrice.vue?vue&type=template&id=13edf394&scoped=true", function () {
      api.rerender('13edf394', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/products/ProductQuickEditSellPrice.vue"
export default component.exports